export default {
  highlightPreTag: `<ais-highlight-0000000000>`,
  highlightPostTag: `</ais-highlight-0000000000>`,
};
